import * as React from 'react';
import { ControlLabel, FormControl, FormGroup, Tab, Tabs } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import CompensableKilometerLimit from './CompensableKilometerLimit';
import PhotographerWorkAreasForm from '../../../PhotographerWorkAreasForm';
import { getSiteName } from '../../../../../shared/Site';
import * as Site from '../../../../../shared/Site';


export type PhotograperWorkareaLabels = {
    deductionLegend: string;
    deductionInputLabel: string;
    workAreasLegend: string;
    travelAdjustmentInputLabel: string;
};

const PhotographerFormComponentWorkArea = (props: any) => {
    let labels: PhotograperWorkareaLabels = {
        deductionLegend: Translate('photographers/modal/form/legend/travel-deduction'),
        deductionInputLabel: Translate('photographer/modal/form/input-label/travel-deduction'),
        workAreasLegend: Translate('photographers/modal/form/legend/workareas'),
        travelAdjustmentInputLabel: Translate(
            'photographer/modal/form/input-label/travel-adjustment'
        )
    };

    function setDefaultConfig(workingAreaMap: any, userSite: number) {
        let workingAreaMaps =
            userSite === 1 /* SE360 */
                ? props.user.se360WorkingAreaMaps
                : props.user.scandphotosWorkingAreaMaps;

        for (let i = 0; i < workingAreaMaps.length; i++) {
            workingAreaMaps[i].polygon = workingAreaMap.polygon;
            workingAreaMaps[i].usePolygon = workingAreaMap.usePolygon;
            workingAreaMaps[i].useCircle = workingAreaMap.useCircle;
            workingAreaMaps[i].circleCenter = workingAreaMap.circleCenter;
            workingAreaMaps[i].circleRadius = workingAreaMap.circleRadius;
            workingAreaMaps[i].base = workingAreaMap.base;
        }

        props.onMapChange(workingAreaMaps, userSite);
    }

    return (
        <>
            <CompensableKilometerLimit
                deductionLegend={labels.deductionLegend}
                deductionInputLabel={labels.deductionInputLabel}
                compensableKilometerLimit={
                    props.user && props.user.compensableKilometerLimit
                        ? props.user.compensableKilometerLimit.toString()
                        : ''
                }
                onChange={props.onChange}
            />
            <fieldset>
                <legend>{labels.workAreasLegend}</legend>
                <FormGroup controlId="photographerTravelAdjustment">
                    <ControlLabel>{labels.travelAdjustmentInputLabel}</ControlLabel>
                    <FormControl
                        type="text"
                        name="travelAdjustment"
                        value={
                            props.user && props.user.travelAdjustment
                                ? props.user.travelAdjustment.toString()
                                : ''
                        }
                        onChange={props.onChange}
                    />
                </FormGroup>
                {props.site === getSiteName(Site.Zentuvo) ?
                    <Tabs defaultActiveKey={1} id="working-areas-uncontrolled-tab">
                        <Tab eventKey={1} title="Zentuvo">
                            <PhotographerWorkAreasForm
                                onMapChange={(x: any) => props.onMapChange(x, 1 /* Se360 */)}
                                photographerId={props.user.id}
                                workingAreaMaps={props.user.se360WorkingAreaMaps}
                                shouldUpdateMap={props.shouldUpdateMap}
                                setDefaultConfigSe360={(x) => setDefaultConfig(x, 1 /* Se360 */)}
                                setDefaultConfigScandphotos={(x) =>
                                    setDefaultConfig(x, 2 /* Scandphotos */)
                                }
                                site={props.site}
                            />
                        </Tab>
                    </Tabs>
                    :
                <Tabs defaultActiveKey={1} id="working-areas-uncontrolled-tab">
                    <Tab eventKey={1} title="SE360">
                        <PhotographerWorkAreasForm
                            onMapChange={(x: any) => props.onMapChange(x, 1 /* Se360 */)}
                            photographerId={props.user.id}
                            workingAreaMaps={props.user.se360WorkingAreaMaps}
                            shouldUpdateMap={props.shouldUpdateMap}
                            setDefaultConfigSe360={(x) => setDefaultConfig(x, 1 /* Se360 */)}
                            setDefaultConfigScandphotos={(x) =>
                                setDefaultConfig(x, 2 /* Scandphotos */)
                            }
                            site={props.site}
                        />
                    </Tab>
                    <Tab eventKey={2} title="Scandphotos">
                        <PhotographerWorkAreasForm
                            onMapChange={(x: any) => props.onMapChange(x, 2 /* Scandphotos */)}
                            photographerId={props.user.id}
                            workingAreaMaps={props.user.scandphotosWorkingAreaMaps}
                            shouldUpdateMap={props.shouldUpdateMap}
                            setDefaultConfigSe360={(x) => setDefaultConfig(x, 1 /* Se360 */)}
                            setDefaultConfigScandphotos={(x) =>
                                setDefaultConfig(x, 2 /* Scandphotos */)
                            }
                            site={props.site}
                        />
                    </Tab>
                </Tabs>
                }
            </fieldset>
        </>
    );
};

export default PhotographerFormComponentWorkArea;
